// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._168kutpp:not(:first-of-type)>p{margin-top:var(--ds-space-150,9pt)}\n._1hms1911{text-decoration-line:line-through}\n._1i4q4jg8{overflow-wrap:normal}", ""]);
// Exports
module.exports = exports;
